import {request} from '@/network/request'

export function standardSpecification(query) {
  return request({
    url: '/gaoligong/standardSpecification/page',
    method: 'get',
    params: query
  })
}

export function addObj(obj) {
  return request({
    url: '/gaoligong/standardSpecification',
    method: 'post',
    data: obj
  })
}

export function getObj(id) {
  return request({
    url: '/gaoligong/standardSpecification/' + id,
    method: 'get'
  })
}

export function delObj(id) {
  return request({
    url: '/gaoligong/standardSpecification/' + id,
    method: 'delete'
  })
}

export function putObj(obj) {
  return request({
    url: '/gaoligong/standardSpecification',
    method: 'put',
    data: obj
  })
}
